import "./index.scss";
import "../../locales/i18n";

import React, { useEffect, useState } from "react";
import Scrollbars from "react-custom-scrollbars";
import { useTranslation } from "react-i18next";

import Button from "@/components/components/Button";
import { ButtonColor } from "@/components/components/Button/button.enum";
import { getDynamicTermsAndConditionsTemplate, getTermsAndConditionsTemplate } from "@/messenger/services/data.service";

interface TermsAndConditionsProps {
    onClick: () => void;
}

const TermsAndConditions: React.FunctionComponent<TermsAndConditionsProps> = (
    termsAndConditionsProps: TermsAndConditionsProps,
) => {
    const [template, setTemplate] = useState(null);
    const { t } = useTranslation();

    const fallBackTemplate = () => {
        getTermsAndConditionsTemplate().then(data => {
            setTemplate(data);
            if (!data || !data.length) {
                let fallback = `
                <html><head></head><body><div>
  <span>1. Introduction</span>
  <p>
    These Website Standard Terms And Conditions (these "Terms" or these "Website
    Standard Terms And Conditions") contained herein on this webpage, shall
    govern your use of this website, including all pages within this website
    (collectively referred to herein below as this "Website"). These Terms apply
    in full force and effect to your use of this Website and by using this
    Website, you expressly accept all terms and conditions contained herein in
    full. You must not use this Website, if you have any objection to any of
    these Website Standard Terms And Conditions. This Website is not for use by
    any minors (defined as those who are not at least 18 years of age), and you
    must not use this Website if you a minor.
  </p>
  <span>2. Intellectual</span>
  <p>
    Property Rights Other than content you own, which you may have opted to
    include on this Website, under these Terms, Statflo, Touchless and/or its
    licensors own all rights to the intellectual property and material contained
    in this Website, and all such rights are reserved. You are granted a limited
    license only, subject to the restrictions provided in these Terms, for
    purposes of viewing the material contained on this Website.
  </p>
  <span>3. Restrictions</span>
  <p>
    You are expressly and emphatically restricted from all of the following:
    publishing any Website material in any media; selling, sublicensing and/or
    otherwise commercializing any Website material; publicly performing and/or
    showing any Website material; using this Website in any way that is, or may
    be, damaging to this Website; using this Website in any way that impacts
    user access to this Website; using this Website contrary to applicable laws
    and regulations, or in a way that causes, or may cause, harm to the Website,
    or to any person or business entity; engaging in any data mining, data
    harvesting, data extracting or any other similar activity in relation to
    this Website, or while using this Website; using this Website to engage in
    any advertising or marketing;
  </p>
</div>
</body></html>`;
                setTemplate(fallback);
            }
        });
    };

    useEffect(() => {
        getDynamicTermsAndConditionsTemplate().then(data => {
            fallBackTemplate();
            /*if(!data){
                fallBackTemplate();
            }else{
                const newTemplate = data?.terms[0]?.value.replace(/\n/g,"<br />");
                setTemplate(newTemplate);
            }*/
        });
    }, []);

    return (
        <div className="c-terms-and-conditions">
            <div className="c-terms-and-conditions__header">
                <div className="c-terms-and-conditions__header-title">{t("Terms and Conditions")}</div>
                <div className="c-terms-and-conditions__header-text">
                    {t("You must read and agree to the Terms and Conditions to use this product.")}
                </div>
            </div>

            {template && (
                <>
                    <div className="c-terms-and-conditions__content-wrapper">
                        <Scrollbars
                            renderTrackVertical={props => (
                                <div {...props} className="c-terms-and-conditions__content-scrollbar-track" />
                            )}
                            renderThumbVertical={props => (
                                <div {...props} className="c-terms-and-conditions__content-scrollbar" />
                            )}
                        >
                            <div
                                className="c-terms-and-conditions__content"
                                dangerouslySetInnerHTML={{ __html: template }}
                            />
                        </Scrollbars>
                    </div>

                    <div className="c-terms-and-conditions__button-wrapper">
                        <Button
                            id={"TERMS_AND_CONDITIONS_ACCEPT_BUTTON"}
                            className="c-terms-and-conditions__button"
                            color={ButtonColor.PRIMARY}
                            onClick={termsAndConditionsProps.onClick}
                            ariaLabel={"Terms and Conditions Accept Button"}
                        >
                            {t("I have read and accept the terms")}
                        </Button>
                    </div>
                </>
            )}
        </div>
    );
};

export default TermsAndConditions;
